// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import store from '@/store' // api: https://github.com/vuejs/vuex
import httpRequest from '@/utils/httpRequest' // api: https://github.com/axios/axios
import VueCookie from 'vue-cookie' // api: https://github.com/alfhen/vue-cookie
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/index.css'
import VueAMap from "vue-amap";
import moment from "moment";
import VueClipboard from 'vue-clipboard2'

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Viewer.setDefaults({
  Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})

Vue.use(VueClipboard)


Vue.use(VueCookie)
Vue.use(ElementUI)
Vue.use(moment)

// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import highcharts from 'highcharts'
import highcharts3d from 'highcharts/highcharts-3d'
highcharts3d(highcharts)

//地图
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
//  修改下面的KEY值
  key:"c2a79693e8b5762940016aa9494b2267",
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  v: '1.4.15',
  uiVersion: '1.0'
})

Vue.config.productionTip = false

// axios请求引入
Vue.prototype.$http = httpRequest // ajax请求方法
Vue.prototype.$moment = moment // ajax请求方法

import Contextmenu from 'vue-contextmenujs'
Vue.use(Contextmenu)

// 将自动注册所有组件为全局组件
import dataV from '@jiaminghi/data-view'
Vue.use(dataV)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js